import { openDB, STORES } from './offlineDB';

export async function getReceiptSettings() {
  try {
    const db = await openDB();
    return await new Promise((resolve) => {
      const request = db.transaction(STORES.SETTINGS, 'readonly').objectStore(STORES.SETTINGS).get('receipt_settings');
      request.onsuccess = () => resolve(request.result?.value || {});
      request.onerror = () => resolve({});
    });
  } catch {
    return {};
  }
}

// Uses the same hidden print frame as Manual Collection, with selectable paper width.
export function printCollectionReceipt(row, centerName, centerAddress, onAfterPrint, paperWidth = '2inch') {
  const paperMm = paperWidth === '3inch' ? 72 : 48;
  const shiftLabel = row.shift === 1 ? 'Morning' : 'Evening';
  const milkLabel = row.milkTypeId === 2 ? 'Buffalo' : 'Cow';
  const now = new Date();
  const timeStr = now.toLocaleTimeString('en-IN', { hour:'2-digit', minute:'2-digit' });
  const dateStr = row.collectionDate
    ? new Date(row.collectionDate).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' })
    : now.toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });

  const html = `<!DOCTYPE html>
<html><head><meta charset="UTF-8"/>
<style>
  @page { size: ${paperMm}mm auto; margin: 0; }
  * { box-sizing:border-box; margin:0; padding:0; font-family:'Courier New',monospace; }
  body { width:${paperMm}mm; font-size:10px; color:#000; padding:2mm; }
  .center { text-align:center; }
  .bold { font-weight:bold; }
  .lg { font-size:13px; }
  .xl { font-size:16px; font-weight:bold; }
  .divider { border-top:1px dashed #000; margin:2mm 0; }
  .row { display:flex; justify-content:space-between; margin:1mm 0; }
  .row .label { color:#444; }
  .row .value { font-weight:bold; }
  .amount-box { border:1px solid #000; text-align:center; padding:2mm; margin:2mm 0; }
  .footer { text-align:center; font-size:9px; color:#666; margin-top:2mm; }
</style>
</head><body>
  <div class="center bold lg">${centerName || 'Dairy Center'}</div>
  ${centerAddress ? `<div class="center" style="font-size:9px;">${centerAddress.replace(/\n/g,'<br/>')}</div>` : ''}
  <div class="center" style="font-size:9px;margin-bottom:1mm;">Collection Receipt</div>
  <div class="divider"></div>
  <div class="row"><span class="label">Date</span><span class="value">${dateStr}</span></div>
  <div class="row"><span class="label">Time</span><span class="value">${timeStr}</span></div>
  <div class="row"><span class="label">Shift</span><span class="value">${shiftLabel}</span></div>
  <div class="divider"></div>
  <div class="row"><span class="label">Code</span><span class="value">${row.code || row.farmerCode || '-'}</span></div>
  <div class="row"><span class="label">Farmer</span><span class="value">${row.name || row.farmerName || '-'}</span></div>
  <div class="row"><span class="label">Milk</span><span class="value">${milkLabel}</span></div>
  <div class="divider"></div>
  <div class="row"><span class="label">Qty (L)</span><span class="value">${parseFloat(row.quantity).toFixed(3)}</span></div>
  <div class="row"><span class="label">FAT</span><span class="value">${parseFloat(row.fat).toFixed(1)}</span></div>
  <div class="row"><span class="label">SNF</span><span class="value">${parseFloat(row.snf).toFixed(1)}</span></div>
  <div class="row"><span class="label">Rate/L</span><span class="value">&#8377;${parseFloat(row.rate).toFixed(2)}</span></div>
  <div class="divider"></div>
  <div class="amount-box">
    <div style="font-size:9px;">TOTAL AMOUNT</div>
    <div class="xl">&#8377; ${parseFloat(row.amount).toFixed(2)}</div>
  </div>
  <div class="footer">Thank you! — Powered by DairyPro</div>
</body></html>`;

  const oldFrame = document.getElementById('dp-print-frame');
  if (oldFrame) oldFrame.remove();

  const frame = document.createElement('iframe');
  frame.id = 'dp-print-frame';
  frame.style.cssText = `position:fixed;top:-9999px;left:-9999px;width:${paperMm}mm;height:1px;border:none;visibility:hidden;`;
  document.body.appendChild(frame);
  frame.onload = () => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } catch (error) {
      console.warn('Print failed:', error);
    }
    setTimeout(() => {
      frame.remove();
      if (onAfterPrint) onAfterPrint();
    }, 500);
  };
  frame.srcdoc = html;
}
